import { ClerkProvider, useAuth } from "@clerk/react";
import { createApiClient, createQueryClient } from "@luckymenu/api-client";
import { ApiProvider } from "@luckymenu/api-client/react";
import { light } from "@luckymenu/design-tokens";
import { I18nProvider } from "@luckymenu/i18n/react";
import { type ReactNode, useRef, useState } from "react";
import { env } from "./env";
import { i18n } from "./i18n";

/** The API client asks Clerk for a fresh token on every request. Same origin `/api`. */
function Api({ children }: { children: ReactNode }) {
	const { getToken } = useAuth();
	const tokenRef = useRef(getToken);
	tokenRef.current = getToken;
	const [client] = useState(() =>
		createApiClient({ url: "/api/trpc", getToken: () => tokenRef.current() }),
	);
	const [queryClient] = useState(createQueryClient);
	return (
		<ApiProvider client={client} queryClient={queryClient}>
			{children}
		</ApiProvider>
	);
}

export function Providers({ children }: { children: ReactNode }) {
	return (
		<I18nProvider i18n={i18n}>
			<ClerkProvider
				publishableKey={env.CLERK_PUBLISHABLE_KEY}
				afterSignOutUrl="/"
				appearance={{
					variables: {
						colorPrimary: light.primary,
						colorForeground: light.foreground,
						borderRadius: "10px",
						fontFamily: '"Inter Variable", Inter, system-ui, sans-serif',
					},
				}}
			>
				<Api>{children}</Api>
			</ClerkProvider>
		</I18nProvider>
	);
}
